import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=dbb2647e&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=dbb2647e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb2647e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbb2647e')) {
      api.createRecord('dbb2647e', component.options)
    } else {
      api.reload('dbb2647e', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=dbb2647e&scoped=true&", function () {
      api.rerender('dbb2647e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SZV0qQX7VOVf/JS/comp/Paginate.vue"
export default component.exports